export class RoomSearchParams {
  readonly prefectureCode: string
  readonly address: string
  readonly name: string
  readonly tgtI: boolean
  readonly tgtP: boolean
  readonly tgtJ: boolean
  readonly tgtA: boolean
  readonly country: string

  constructor(params: {
    prefectureCode?: string
    address?: string
    name?: string
    tgtI?: boolean
    tgtP?: boolean
    tgtJ?: boolean
    tgtA?: boolean
    country?: string
  }) {
    this.prefectureCode = params.prefectureCode || ''
    this.address = params.address || ''
    this.name = params.name || ''
    this.tgtI = !!params.tgtI
    this.tgtP = !!params.tgtP
    this.tgtJ = !!params.tgtJ
    this.tgtA = !!params.tgtA
    this.country = params.country || ''
  }

  // eslint-disable-next-line
  toQueryParams() {
    return {
      prefecture_code: this.prefectureCode,
      address: this.address,
      name: this.name,
      tgt_i: this.tgtI ? '1' : '',
      tgt_p: this.tgtP ? '1' : '',
      tgt_j: this.tgtJ ? '1' : '',
      tgt_a: this.tgtA ? '1' : '',
      country: this.country,
    }
  }

  static fromURLSearchParams(params: URLSearchParams): RoomSearchParams {
    return new RoomSearchParams({
      prefectureCode: params.get('prefecture_code') || undefined,
      address: params.get('address') || '',
      name: params.get('name') || '',
      tgtI: !!params.get('tgt_i'),
      tgtP: !!params.get('tgt_p'),
      tgtJ: !!params.get('tgt_j'),
      tgtA: !!params.get('tgt_a'),
      country: params.get('country') || '',
    })
  }
}

export class RoomSearchResultItem {
  readonly id: number
  readonly code: string
  readonly name: string
  readonly kana: string
  readonly postalCode: string
  readonly prefecture: string
  readonly prefectureCode: string
  readonly address1: string
  readonly address2: string
  readonly address3: string
  readonly tel: string
  readonly contactEmail: string
  readonly url: string
  readonly tgtI: boolean
  readonly tgtP: boolean
  readonly tgtJ: boolean
  readonly tgtA: boolean
  constructor(room: {
    id: number
    code: string
    name: string
    kana: string
    postalCode: string
    prefecture: string
    prefectureCode: string
    address1: string
    address2: string
    address3: string
    tel: string
    contactEmail: string
    url: string
    tgtI: boolean
    tgtP: boolean
    tgtJ: boolean
    tgtA: boolean
  }) {
    this.id = room.id
    this.code = room.code
    this.name = room.name
    this.kana = room.kana
    this.postalCode = room.postalCode
    this.prefecture = room.prefecture
    this.prefectureCode = room.prefectureCode
    this.address1 = room.address1
    this.address2 = room.address2
    this.address3 = room.address3
    this.tel = room.tel
    this.contactEmail = room.contactEmail
    this.url = room.url
    this.tgtI = room.tgtI
    this.tgtP = room.tgtP
    this.tgtJ = room.tgtJ
    this.tgtA = room.tgtA
  }

  // eslint-disable-next-line
  static fromApiData(room: any): RoomSearchResultItem {
    return new RoomSearchResultItem({
      id: room.id || 0,
      code: room.code || '',
      name: room.name || '',
      kana: room.kana || '',
      postalCode: room.postal_code || '',
      prefecture: room.prefecture || '',
      prefectureCode: room.prefecture_code || '',
      address1: room.address1 || '',
      address2: room.address2 || '',
      address3: room.address3 || '',
      tel: room.tel || '',
      contactEmail: room.contact_email || '',
      url: room.url || '',
      tgtI: !!room.tgt_i,
      tgtP: !!room.tgt_p,
      tgtJ: !!room.tgt_j,
      tgtA: !!room.tgt_a,
    })
  }
}

export class RoomSearchResult {
  readonly rooms: RoomSearchResultItem[]

  constructor(rooms: RoomSearchResultItem[]) {
    this.rooms = rooms
  }

  static fromApiData(data: { rooms: [] }): RoomSearchResult {
    const rooms: RoomSearchResultItem[] = data.rooms.map((room) => {
      return RoomSearchResultItem.fromApiData(room)
    })
    return new RoomSearchResult(rooms)
  }
}
